module.exports = __webpack_public_path__ + "img/穿心莲.e2af481c.jpg";